import React, { Component } from "react";

const PortfolioListContent = [
    {
        image: 'image-1',
        category: ' Fotografia',
        title: 'Camaras y Accesorios'
    },
    {
        image: 'image-3',
        category: 'Accesorios',
        title: ' Impresoras y Suministros'
    },
    {
        image: 'image-4',
        category: 'Fotografia',
        title: ' Albunes y Marcos'
    },
    {
        image: 'image-2',
        category: 'Accesorios',
        title: ' Tecnologia y Accesorios'
    }
]

class PortfolioList extends Component{
    render(){
        const {column , styevariation } = this.props;
        const list = PortfolioListContent.slice(0 , this.props.item);
        return(
            <React.Fragment> 
                {list.map((value , index) => (
                    <div className={`${column}`} key={index}>
                        <div className={`portfolio ${styevariation}`}>
                            <div className="thumbnail-inner">
                                <div className={`thumbnail ${value.image}`}></div>
                                <div className={`bg-blr-image ${value.image}`}></div>
                            </div>
                            <div className="content">
                                <div className="inner">
                                    <p>{value.category}</p>
                                    <h4>{value.title}</h4>
                                    <div className="portfolio-button">
                                        <a className="rn-btn" href="mailto:hola@fotolab.com.gt">Cotizanos</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
               
            </React.Fragment>
        )
    }
}
export default PortfolioList;